module.exports = __webpack_public_path__ + "static/img/reload.a74f4ced.svg";